import React from 'react';
import { Box, VisuallyHidden } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

// There is also a vanilla CSS version of this used in:
// cas/frontend/student-list/index.html
// configuration/frontend/configuration/index.html
// don't forget to update this with any changes made here

interface SpinnerProps {
  size?: string;
  duration?: string;
  hiddenText?: string;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  30% { transform: rotate(90deg); }
  45% { transform: rotate(180deg); }
  65% { transform: rotate(270deg); }
  100% { transform: rotate(360deg); }
`;

const pseudoCommon = {
  content: '""',
  display: 'block',
  height: '0.5em',
  width: '0.5em',
  position: 'absolute',
  borderRadius: 'full',
  borderStyle: 'solid',
  borderWidth: '0.125em',
};

export const Spinner = ({
  size = '96px',
  duration = '1.25s',
  hiddenText = 'Loading...',
}: SpinnerProps): React.ReactElement => (
  <Box
    bgColor="utility.900"
    borderRadius="full"
    color="white"
    display="inline-flex"
    fontSize={size}
    height="1em"
    width="1em"
    position="relative"
    alignItems="center"
    justifyContent="center"
    _before={{
      ...pseudoCommon,
      borderColor: 'whiteAlpha.200',
    }}
    _after={{
      ...pseudoCommon,
      borderColor: 'transparent',
      borderTopColor: 'yellow.400',
      animation: `2.5s ${spin} linear infinite`,

      '@media (prefers-reduced-motion: no-preference)': {
        animation: `${duration} ${spin} linear infinite`,
      },
    }}
  >
    <VisuallyHidden>{hiddenText}</VisuallyHidden>
  </Box>
);
